import { useEffect, useState } from 'react';

/**
 * How long the conversation has been going, in whole seconds.
 *
 * Counted from the moment it started rather than from a timestamp the server
 * holds: what the clock is for is knowing how long you have been talking, and
 * that begins when the other side answers, not when the row was written.
 */
export function useElapsedSeconds(running: boolean): number {
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    if (!running) {
      return;
    }

    const timer = setInterval(() => setSeconds((count) => count + 1), 1_000);
    return () => clearInterval(timer);
  }, [running]);

  return seconds;
}
